import { lazy } from "react";
import { createBrowserRouter } from "react-router";

import { Root } from "./components/Root";

// Lazy load page components for better code splitting
const Home = lazy(() => import("./pages/Home").then((m) => ({ default: m.Home })));
const StudioRecording = lazy(() =>
  import("./pages/StudioRecording").then((m) => ({ default: m.StudioRecording }))
);
const Events = lazy(() => import("./pages/Events").then((m) => ({ default: m.Events })));
const EventDetail = lazy(() =>
  import("./pages/EventDetail").then((m) => ({ default: m.EventDetail }))
);
const Dashboard = lazy(() => import("./pages/Dashboard").then((m) => ({ default: m.Dashboard })));
const ResidentArtists = lazy(() =>
  import("./pages/ResidentArtists").then((m) => ({ default: m.ResidentArtists }))
);
const News = lazy(() => import("./pages/News").then((m) => ({ default: m.News })));
const About = lazy(() => import("./pages/About").then((m) => ({ default: m.About })));
const BookContact = lazy(() =>
  import("./pages/BookContact").then((m) => ({ default: m.BookContact }))
);
const Contact = lazy(() => import("./pages/Contact").then((m) => ({ default: m.Contact })));
const Login = lazy(() => import("./pages/Login").then((m) => ({ default: m.Login })));

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Root,
    children: [
      { index: true, Component: Home },
      { path: "studio", Component: StudioRecording },
      { path: "events", Component: Events },
      { path: "events/:slug", Component: EventDetail },
      { path: "dashboard", Component: Dashboard },
      { path: "residents", Component: ResidentArtists },
      { path: "news", Component: News },
      { path: "about", Component: About },
      { path: "book", Component: BookContact },
      { path: "contact", Component: Contact },
      { path: "login", Component: Login },
    ],
  },
]);
